import Section from '../Section'
import { support } from '../utils'
import gsap from 'gsap'

class IntroParallax extends Section {
  constructor(opts) {
    super(opts)

    if (support.touch) return

    this.DOM = this.getDOM()
    this.tl = this.createTimeline()

    if (this.DOM.video) {
      if (this.DOM.video.playing) {
        this.DOM.image.style.display = 'none'
      } else {
        this.DOM.video.addEventListener('play', () => {
          this.DOM.image.style.display = 'none'
        })
      }
    }
  }

  getDOM() {
    return {
      headline: document.querySelectorAll('.introduction h1'),
      image: document.querySelector('#introduction-image img'),
      video: document.querySelector('#introduction-image video'),
      shapeOne: document.querySelector('.yellow-shape--one'),
      shapeTwo: document.querySelector('.yellow-shape--two'),
    }
  }

  createTimeline() {
    const tl = new gsap.timeline({ paused: true })

    tl.to(
      this.DOM.headline,
      { y: -50, force3D: true, ease: 'Linear.easeNone' },
      0
    )
      .to(
        this.DOM.shapeOne,
        {
          x: '150px',
          rotation: '40deg',
          force3D: true,
          ease: 'Linear.easeNone',
        },
        0
      )
      .to(
        this.DOM.shapeTwo,
        {
          y: '-50px',
          x: window.innerWidth > 1440 ? '400px' : 0,
          rotation: '10deg',
          force3D: true,
          scale: 0.8,
          ease: 'Linear.easeNone',
        },
        0
      )

    tl.progress(1)

    return tl
  }

  run(opts) {
    super.run(opts)
    this.tl.progress(this.data.progress)
  }
}

export default IntroParallax
